/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { APITicketUser } from './APITicketUser';
import {
    APITicketUserFromJSON,
    APITicketUserFromJSONTyped,
    APITicketUserToJSON,
} from './APITicketUser';

/**
 * 
 * @export
 * @interface APITicketSearchResult
 */
export interface APITicketSearchResult {
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof APITicketSearchResult
     */
    score: number | null;
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    subject: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    message?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    response?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    type?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    status?: string;
    /**
     * 
     * @type {boolean}
     * @memberof APITicketSearchResult
     */
    shared?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof APITicketSearchResult
     */
    createdAt?: Date | null;
    /**
     * 
     * @type {APITicketUser}
     * @memberof APITicketSearchResult
     */
    user?: APITicketUser | null;
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    userEmail?: string;
    /**
     * 
     * @type {string}
     * @memberof APITicketSearchResult
     */
    rootAccountId?: string | null;
}

/**
 * Check if a given object implements the APITicketSearchResult interface.
 */
export function instanceOfAPITicketSearchResult(value: object): value is APITicketSearchResult {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('score' in value) || value['score'] === undefined) return false;
    if (!('subject' in value) || value['subject'] === undefined) return false;
    return true;
}

export function APITicketSearchResultFromJSON(json: any): APITicketSearchResult {
    return APITicketSearchResultFromJSONTyped(json, false);
}

export function APITicketSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): APITicketSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'score': json['score'],
        'subject': json['subject'],
        'message': json['message'] == null ? undefined : json['message'],
        'response': json['response'] == null ? undefined : json['response'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'shared': json['shared'] == null ? undefined : json['shared'],
        'createdAt': json['created_at'] == null ? undefined : (new Date(json['created_at'])),
        'user': json['user'] == null ? undefined : APITicketUserFromJSON(json['user']),
        'userEmail': json['user_email'] == null ? undefined : json['user_email'],
        'rootAccountId': json['root_account_id'] == null ? undefined : json['root_account_id'],
    };
}

export function APITicketSearchResultToJSON(value?: APITicketSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'score': value['score'],
        'subject': value['subject'],
        'message': value['message'],
        'response': value['response'],
        'type': value['type'],
        'status': value['status'],
        'shared': value['shared'],
        'created_at': value['createdAt'] == null ? undefined : ((value['createdAt'] as any).toISOString()),
        'user': APITicketUserToJSON(value['user']),
        'user_email': value['userEmail'],
        'root_account_id': value['rootAccountId'],
    };
}

